import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../types/global';
import applicationListSelectors from '../../modules/application/list/applicationListSelectors';
import { selectEnvironment } from '../../modules/global';
import { internationalAvsStorage } from './internationalAvsStorage';
import { internationalAvsAnalytics } from './internationalAvsAnalytics';
import { requestServiceAccess, UpgradeType } from '../../modules/avs';
import { isKSACountry } from '../../config/countriesEnvironments';

export function useInternationalAvsPromotionBannerHandler(): {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  handleTryNow: () => void;
  handleReadDocumentation: () => void;
  isRequestButtonDisabled: boolean;
} {
  const dispatch = useDispatch();
  const environment = useTypedSelector(selectEnvironment);
  const application = useTypedSelector(
    applicationListSelectors.selectApplication,
  );

  const [isVisible, setIsVisible] = useState(() =>
    application?.id
      ? internationalAvsStorage.shouldShowBanner(environment, application.id)
      : false,
  );
  
  const [isRequestButtonDisabled, setIsRequestButtonDisabled] = useState(false);

  useEffect(() => {
    if (application?.id) {
      internationalAvsStorage.initializeBannerFirstSeen(
        environment,
        application.id,
      );
    }
  }, [environment, application?.id]);

  const handleTryNow = () => {
    if (application?.id && !isRequestButtonDisabled) {
      setIsRequestButtonDisabled(true);
      internationalAvsAnalytics.trackBannerRequestAccessClick(application.id);
      dispatch(
        requestServiceAccess({
          appToken: application.id,
          upgradeType: UpgradeType.INTERNATIONAL_AVS,
        }),
      );
    }
  };

  const handleReadDocumentation = () => {
    if (application?.id) {
      internationalAvsAnalytics.trackBannerDocumentationClick(application.id);

      let documentationUrl;

      if (isKSACountry) {
        documentationUrl = 'https://docs.leantech.me/v2.0-KSA/docs/how-to-use-international-account-verification#/';
      } else {
        documentationUrl = 'https://docs.leantech.me/docs/how-to-use-international-account-verification#/';
      }

      window.open(documentationUrl, '_blank');
    }
  };

  return {
    isVisible,
    setIsVisible,
    handleTryNow,
    handleReadDocumentation,
    isRequestButtonDisabled,
  };
}